<template>
  <v-container>
    <h1 class="display-1 font-weight-bold mx-1 mb-3">Download Images</h1>
    <v-card>
      <v-card-title>Artist Images </v-card-title>
      <v-card-text>
        <div class="d-flex" v-if="!artistsLoading">
          <v-autocomplete
            class="mr-2"
            v-model="selectedArtist"
            :items="artists"
            outlined
            clearable
            clear-icon="mdi-close-box"
            dense
            item-text="name"
            return-object="true"
            :label="'Artist'"
          ></v-autocomplete>
        </div>
        <v-card-text v-if="artistsLoading" class="mt-4 text-center">
          <h2 class="mt-4 mb-4 text-center">Loading artists...</h2>
          <v-progress-circular
            indeterminate
            :size="30"
            :width="3"
            color="green"
          ></v-progress-circular>
        </v-card-text>
        <v-btn
          class="mb-4"
          v-if="selectedArtist"
          color="success"
          @click.stop="downloadImagesZip(selectedArtist)"
        >
          Download giclee images
          <v-icon class="ml-4"> mdi-download </v-icon>
        </v-btn>
        <v-card-text v-if="loading" class="mt-4 text-center">
          <h2 class="mt-4 mb-4 text-center">{{ loadingText }}</h2>
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="green"
          ></v-progress-circular>
        </v-card-text>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ArtistApi from "@/api/customer/artist";
import ProductApi from "@/api/customer/product";

export default {
  data() {
    return {
      type: null,
      imageUrl: process.env.VUE_APP_IMG_URL,
      selectedArtist: null,
      artistsLoading: true,
      loading: false,
      loadingText: null,
    };
  },
  async created() {
    ArtistApi.loadArtists().then((res) => {
      this.artistsLoading = true;
      this.artists = res.data;
      this.artistsLoading = false;
    });
  },
  methods: {
    async downloadImagesZip(artist) {
      this.loadingText = "Please wait while we create the zip file";
      this.loading = true;
      ProductApi.getImagesZip(artist).then((results) => {
        this.loading = false;
      });
    },
  },
};
</script>
